import React, { Component } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';

class FormReportModal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    articlecolumns = [
        {
            dataField: 'source_name',
            text: 'source name',
            sort: true,
        },
        {
            dataField: 'source_count',
            text: 'source count ',
            sort: true,
        },
    ];

    render() {

        console.log("dataaaaa", this.props.stateData?.existingAdmissionFormFields?.[0]?.source_details);
 
        return (
            <Modal {...this.props} size="md" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg">Enquiry Form Report</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} className='table_bottom'>
                            {
                               this.props.stateData?.existingAdmissionFormFields?.[0]?.source_details.length > 0 ? (
                                    <CardLessDataTable
                                    particlecolumns={this.articlecolumns}
                                    SearchBar={true}
                                    parentData={this.props.stateData.existingAdmissionFormFields[0]?.source_details}
                                    name="hostel_attendance"
                                />
                                ):(
                                    <h6 className="text-center mt-5">No Data Available</h6>
                                ) 
                            }
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }
}

export default FormReportModal;
